import React from 'react'
import Autosuggest from 'react-autosuggest'

/**
* Wrapper component for the `Autosuggest` component. This adds common settings
* that will be used anytime the `Autosuggest` component should be used.
*/
function Typeahead(props) {
  const theme = {
    container: 'typeahead',
    containerOpen: 'is-open',
    input: 'input typeahead-input',
    inputOpen: 'is-open',
    inputFocused: 'is-active',
    suggestionsContainer: 'typeahead-suggestions-container',
    suggestionsContainerOpen: 'is-open',
    suggestionsList: 'menu-list typeahead-suggestions-list',
    suggestion: 'typeahead-suggestion',
    suggestionFirst: 'is-first',
    suggestionHighlighted: 'is-active',
    sectionContainer: 'menu typeahead-section-container',
    sectionContainerFirst: 'is-first',
    sectionTitle: 'menu-label typeahead-section-title',
  }

  return (
    <div>
      <Autosuggest
        renderSectionTitle={() => false}
        shouldRenderSuggestions={() => true}
        theme={theme}
        {...props}
      />
      <div className="overlay" />
    </div>
  )
}

export default Typeahead
